/**
 * Stitch types whose "Distance between needle" field is editable under the GSD V4 calculation engine.
 *
 * For any other stitch type the field behaviour is unchanged (backward compatible) and the value is
 * not captured. This list mirrors the server-side set in `V4OperationHelper.EditableNeedleDistanceStitchTypeCodes`.
 */
export const EDITABLE_NEEDLE_DISTANCE_STITCH_TYPE_CODES: readonly string[] = [
  "305",
  "310",
  "312",
  "405",
  "506",
  "507",
  "508",
  "509",
  "510",
  "511",
  "512",
  "514",
  "521"
];

/**
 * Returns true when the given stitch type code has an editable "Distance between needle" field under GSD V4.
 */
export function isEditableNeedleDistanceStitchType(stitchTypeCode?: string | null): boolean {
  if (!stitchTypeCode) {
    return false;
  }
  // The edit form may carry the code with a "-description" suffix; compare on the base code only.
  const baseCode = stitchTypeCode.split("-")[0].trim();
  return EDITABLE_NEEDLE_DISTANCE_STITCH_TYPE_CODES.includes(baseCode);
}
